import styled from 'styled-components';

export const ClientSettingsConstants = {
  SETTINGS_TAB_ID: 'settings',
  INTEGRATIONS_TAB_ID: 'integrations',
  MARKETING_PERMISSIONS_TAB_ID: 'marketing-permissions',
  VOUCHER_CODES_TAB_ID: 'voucher-codes',
};

export const NEW_GROUP_TO_MOVE_TO = 'NewMoveGroup';
export const NEW_BRAND_TO_MOVE_TO = 'NewMoveBrand';

export const MoveElementLink = styled.div`
  display: inline-flex;
  cursor: pointer;
`;
